import { VolumeDataType } from "../EditProject/RightSide/FtlTab/InboundPipeline/ExtractVolumeDataFromBlob";

export class PdsrKey {
  containerNetwork: string;
  plantGsdb: string;
  dockCode: string;
  supplierGsdb: string;

  constructor(containerNetwork: string, plantGsdb: string, dockCode: string, supplierGsdb: string) {
    this.containerNetwork = containerNetwork;
    this.plantGsdb = plantGsdb;
    this.dockCode = dockCode;
    this.supplierGsdb = supplierGsdb;
  }

  static toPdsrKey = (volumeDataType: VolumeDataType) => {
    return new PdsrKey(
      volumeDataType.Network,
      volumeDataType.Col1,
      volumeDataType.Col2,
      volumeDataType.Col3
    );
  };
}
